module.exports = __webpack_public_path__ + "media/images/favicon/favicon-0b7afe40a8f56c7ada3bfb0fb83b2ba7.ico";